import type { SyncEntity, SyncOperation, SyncQueueItem } from './syncTypes';

export function toOnlineCommandItem(
  entity: SyncEntity,
  operation: SyncOperation,
  payload: Record<string, unknown>,
): SyncQueueItem {
  return {
    id: 'online',
    entity,
    operation,
    payload,
    status: 'pending',
  };
}
